import { motion } from 'framer-motion';
import { Card } from '@/components/ui/Card';

const testimonials = [
  {
    quote:
      'My work goes unnoticed. Five analyzes the situation and suggests a 5-minute action: crafting a data-driven email to highlight key wins to leadership.',
    name: 'Marketing Manager',
    role: 'Campaign Results Invisible',
  },
  {
    quote:
      'Will AI replace my role? Five creates a personalized learning path with specific AI tools for financial modeling, positioning me as an innovation leader.',
    name: 'Finance Director',
    role: 'Worried About Staying Relevant',
  },
  {
    quote:
      "I don't know the right people. Five identifies key product managers to connect with and provides conversation starters for strategic coffee chats.",
    name: 'Software Engineer',
    role: 'Wanting to Expand Beyond Tech',
  },
  {
    quote:
      'I struggle in leadership meetings. Five breaks down executive communication patterns and provides frameworks for confident participation.',
    name: 'Senior Analyst',
    role: 'Intimidated in C-Suite Discussions',
  },
  {
    quote:
      'I feel stuck with no clear path. Five analyzes my skills, market trends, and company dynamics to identify specific advancement opportunities.',
    name: 'Operations Manager',
    role: 'Uncertain About Next Move',
  },
  {
    quote:
      'Technology is moving too fast. Five curates micro-learning modules and creates implementation strategies that demonstrate thought leadership.',
    name: 'HR Director',
    role: 'Overwhelmed by Digital Transformation',
  },
];

export const Testimonials = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/[0.02] to-transparent" />
      <div className="container relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 tracking-tight">
            <span className="text-foreground">How Professionals </span>
            <span className="bg-gradient-to-r from-primary via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">
              Use Five
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Daily actions transformed into career breakthroughs
          </p>
        </motion.div>

        <div className="relative">
          <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.06 }}
                className="flex-shrink-0 w-80 snap-start"
              >
                <Card className="p-6 h-full border-2 rounded-2xl bg-gradient-to-br from-primary/5 to-violet-500/5 hover:border-primary/40 transition-all duration-300 shadow-sm">
                  <p className="text-foreground mb-6 leading-relaxed text-lg">
                    &quot;{testimonial.quote}&quot;
                  </p>
                  <div className="border-t border-border pt-4">
                    <p className="font-semibold text-foreground">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-muted-foreground">
                      {testimonial.role}
                    </p>
                  </div>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

